<template>
  <div
    class="swiper-container"
    v-observe-visibility="{
      callback: VisibilityChanged,
      once: true,
    }"
  >
    <slot name="before-wrapper" />
    <div class="swiper-wrapper">
      <slot />
    </div>
    <div v-if="defaultPagination" class="swiper-pagination" />
    <div v-if="defaultScrollbars" class="swiper-scrollbar" />
    <div v-if="defaultNavigation" class="swiper-button-prev" tabindex="-1" />
    <div v-if="defaultNavigation" class="swiper-button-next" tabindex="-1" />
    <slot name="after-wrapper" />
  </div>
</template>

<script>
import {
  A11y,
  Keyboard,
  Navigation,
  Pagination,
  Swiper,
} from 'swiper/swiper.esm.js';
import { eventBus } from '../../main';

Swiper.use([Navigation, Pagination, Keyboard, A11y]);

export default {
  name: 'swiper-container',
  props: {
    options: { type: Object, required: true },
  },

  computed: {
    defaultPagination() {
      return this.options.pagination && !this.options.pagination.el;
    },
    defaultScrollbars() {
      return this.options.scrollbar && !this.options.scrollbar.el;
    },
    defaultNavigation() {
      const { navigation: nav } = this.options;
      return nav && nav.nextEl && nav.prevEl;
    },
  },

  watch: {
    options() {
      this.recreateSwiper();
    },
  },

  mounted() {
    var vm = this;
  },

  updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },

  beforeDestroy() {
    if (this.swiper) this.swiper.destroy();
  },

  methods: {
    control(swiper) {
      this.controlled = swiper;
      this.recreateSwiper();
    },

    recreateSwiper() {
      if (this.swiper) this.swiper.destroy();

      this.swiper = new Swiper(
        this.$el,
        Object.assign(
          {},
          {
            preloadImages: false,
            keyboard: {
              enabled: false,
              onlyInViewport: true,
            },
            a11y: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              //   el: '.swiper-pagination',
              //   type: 'bullets',
              //   bulletElement: 'span',
            },
          },
          this.options,
          {
            controller: {
              control: this.controlled,
              by: 'container',
            },
          }
        )
      );
      this.$emit('update:swiper', this.swiper);
    },
    async VisibilityChanged(isVisible, entry) {
      if (isVisible) {
        await this.$nextTick();
        this.recreateSwiper();
      }
    },
  },
};
</script>
